<template>
    <center class="home pb-5 bg-dark text-light">
		<div class="row">
			<div class="col-12 col-md-4 mb-5 mb-md-0">
				<h5>Welcome</h5>
				<div>
					My name is <a href="https://www.facebook.com/hieupham19072001/" target="_blank">Pham Trung Hieu</a>,
					i'm looking for a Software Development job.
					Here is my <a href="https://www.topcv.vn/xem-cv/A1ZUUlIFVQZRDlcAXVdWBFRTUQRZVlQBUFUFUg2e50" target="_blank">CV</a>.<br>
					If you are wondering am i the one you're looking for, 
					please give me a call ( 0989063201 ) and let me convince you.
				</div>
			</div>
			<div class="col-12 col-md-8">
				<h5>About Me</h5>
				<div class="text-light text-left">
					-I'm studying Computer Enginering at Hanoi University of Science and Technology.<br>
					-I have exprerience in Web Development since March 2020.<br>
					-I can read and use English Technology Documents.<br>
					-I have exprerience in using Linux Ubuntu OS.<br>
					-I have exprerience in working in a team and working for clients.<br>
					-A few of my projects are listed down below.<br>
				</div>
			</div>
		</div>
		<h3>My Projects</h3>
        <div class="container">
                <ParalaxCard v-for="route in pages"
                    :key="route.name" :data-image="host + '/demo/' + route.name + '.png'"
					class="cursor-pointer"
					@click.native="$router.push(route.path)">
                    <h1 slot="header">{{ route.name }}</h1>
                    <p slot="content">{{ route.describe }}</p>
                </ParalaxCard>
        </div>
    </center>
</template>

<script>
import ParalaxCard from '@/components/Paralax/Card.vue'
import { contentHost } from '@/api/constant.js'

export default {
    name: 'Home',
    components: { ParalaxCard },
	data(){
		let pages = []
		for (let p of this.$router.options.routes[this.$router.options.routes.length - 1].children) {
			if (p.hideInMenu) continue
			pages.push(p)
		}
        return {
            scene: null,
            camera: null,
            renderer: null,
            torusKnob: null,
            interactionManager: null,
            isLeaving: false,
            projects: [],
            isMouseOver: false,
            board: null,
			pages: pages,
			host: contentHost,
        }
    },
    methods:{
    },
}
</script>
<style scoped>
	.row{
		padding: 0 20%;
	}
	.col-md-8{
		position: relative;
		top: -50px;
		background: linear-gradient(-45deg, #2d9254, #68CCCA);
		min-height: 100px;
		border-radius: 10px;
	}
	img{
		width: 100%;
		min-height: 100px;
	}
	.d-md-flex{
        overflow-y: unset;
		overflow-x: auto;
		max-height: 300px;
	}
    .container {
        padding: 40px 80px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
</style>
